export default __webpack_public_path__ + "static/media/penguin-5.0c71b917.png";